<script lang="ts" setup>
import { computed } from 'vue';
import { icons } from '../foundation/services/constants/collection-icons';
import { MdiFaIcon } from '@ilteducation/components';

type Props = {
  symbol?: string;
  size?: number;
};

const props = withDefaults(defineProps<Props>(), {
  symbol: 'circle',
  size: 24,
});

const icon = computed(() => {
  // 1. Check if the symbol exists in your predefined collection-icons
  const mappedFaIcon = icons[props.symbol]?.icon;
  if (mappedFaIcon) return mappedFaIcon;

  // 2. Logic to handle raw MDI strings if passed directly (e.g., "mdi-home")
  if (props.symbol.startsWith('mdi-')) return props.symbol;

  // 3. Fallback
  return 'fa-regular fa-circle';
});
</script>

<template>
  <MdiFaIcon :icon="icon" :size="size" />
</template>
